const readAuthDataFromSessionStorage = () =>
  JSON.parse(sessionStorage.getItem(
      `oidc.user:https://alltecheco2auth.azurewebsites.net/:${process.env.REACT_APP_CLIENT_ID}`
  ));
export { readAuthDataFromSessionStorage };
